import React from 'react';
import { Outlet } from 'react-router-dom';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950">
      <Outlet />
    </div>
  );
};

export default Layout;
